import { AddressKeys } from "core-lib/types/Address";

export enum PopUpState {
  SelectAddress = 'selectAddress',
  MapAddress="mapAddress"
}

export enum AddressTypeList {
  Home = 'HOME',
  Office = 'OFFICE',
  Other = 'OTHER',
}

export const saveAddressType = [
  {
    id: 1,
    name: 'Home',
  },
  {
    id: 2,
    name: 'Office',
  },
  {
    id: 3,
    name: 'Other',
  },
];


export enum ModalVariant {
  BottomSheet = "bottomSheet",
  Page = "page",
}

export const RequiredAddressFields: AddressKeys[] = [
  'pincode',
  'city',
  'state',
  'latitude',
  'longitude',
];
